// extracted by mini-css-extract-plugin
export var btn = "banner-module--btn--C3EjH";
export var btnBlock = "banner-module--btnBlock--uDQE7";
export var container = "banner-module--container--iWV91";
export var hideMobBlock = "banner-module--hideMobBlock--1y2xz";
export var img = "banner-module--img--3qfM1";
export var imgCreditCard = "banner-module--imgCreditCard--jgLXw";
export var imgHalva = "banner-module--imgHalva--YX+1k";
export var imgWrapper = "banner-module--imgWrapper--cpMi1";
export var mobBtn = "banner-module--mobBtn--SNEQb";
export var secondContainer = "banner-module--secondContainer---0u7j";
export var section = "banner-module--section--bdg2C";
export var textBlock = "banner-module--textBlock--KTokN";